
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.86.59a18.66 18.66 0 002.98 3.9c1.7 1.7 3.73 3.08 5.98 4.03 2.25.95 4.73 1.48 7.32 1.48-1.65 0-3.29.2-4.87.63-2.33.62-4.53 1.69-6.48 3.16a18.708 18.708 0 00-4.94 5.6c.82-1.43 1.47-2.95 1.89-4.53.62-2.33.8-4.77.5-7.2-.3-2.43-1.08-4.83-2.38-7.08z","fill":"none","stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    